import React from 'react'
import { FormattedMessage } from 'react-intl'

const minLatitude = -90
const maxLatitude = 90

export default class IsLatitude {
  constructor({ value }) {
    this.value = value
    this.errorMessage = <FormattedMessage id="invalid_latitude" />
  }

  validate() {
    const { value } = this

    if (value < minLatitude || value > maxLatitude) {
      return this.errorMessage
    }

    return null
  }
}
